<template>
  <div>
    <NuxtLayout name="resource" :item="item">
      <template #content>
        <div class="my-4">
          <a
            :href="`https://research.sats.ac.za/items/${item.thesis_uuid}`"
            target="_blank"
            class="btn dspace-link"
          >
            View on DSpace
          </a>
        </div>
        <DeferredContent @load="loadPDF(item.thesis_uuid)">
          <div class="py-0 w-full">
            <div class="w-full flex justify-content-center">
              <ClientOnly>
                <PdfViewer
                  v-if="!loadingPDF && pdfURL"
                  :item="{ pdf: pdfURL }"
                  :external="true"
                />
                <div
                  v-else-if="loadingPDF"
                  class="w-full flex justify-content-center"
                >
                  <ProgressSpinner />
                </div>
                <div v-else class="font-light">No PDF link found.</div>
              </ClientOnly>
            </div>
          </div>
        </DeferredContent>
      </template>
    </NuxtLayout>
  </div>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})

const loadingPDF = ref(true)
const pdfURL = ref('')

async function loadPDF(uuid) {
  const pdfBlob = await $fetch(`/api/dspace/pdf`, {
    params: { uuid },
    responseType: 'blob'
  })

  if (pdfBlob) {
    pdfURL.value = URL.createObjectURL(
      new Blob([pdfBlob], { type: 'application/pdf' })
    )
  }

  loadingPDF.value = false
}
</script>
